import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import {
  Alert,
  Button,
  Col,
  Container,
  Form,
  FormControl,
  FormGroup,
  FormLabel,
  Row,
} from "react-bootstrap";
import {
  FilledInvite,
  InviteInfo,
  InviteToken,
  UserCredential,
} from "../../store/auth/types";
import { ApplicationState } from "../../store";
import { bindActionCreators, Dispatch } from "redux";
import {
  acceptInvite,
  getInviteInfo,
  loginUser,
} from "../../store/auth/actions";
import { connect } from "react-redux";
import LoadingIndicator from "../common/onboarding/LoadingIndicator";
import { push } from "connected-react-router";
import { toastr } from "react-redux-toastr";
import { TermsAndConditionsModal } from "./terms-and-conditions/TermsAndConditionsModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { validatePasswordWithDOM } from "../../utils/PasswordValidation";

type PropsFromState = {
  isLoading: {
    getInviteInfo: boolean;
    acceptInvite: boolean;
  };
  errors: {
    getInviteInfo?: string;
    acceptInvite?: string;
  };
  inviteInfo?: InviteInfo;
};

type DispatchProps = {
  loginUser: (user: UserCredential) => any;
  push: (location: string) => any;
  getInviteInfo: (inviteToken: InviteToken) => any;
  acceptInvite: (filledInvite: FilledInvite) => any;
};

type MatchParams = {
  code: string;
};

type Props = PropsFromState & DispatchProps & RouteComponentProps<MatchParams>;

type State = {
  first_name: string;
  last_name: string;
  email: string;
  code: string;
  password: string;
  confirmPassword: string;
  passwordsMatch: boolean;
  showTermsAndConditionsModal: boolean;
  attributeType: string;
  attributeConfirmType: string;
  isPasswordFieldsValid: boolean;
};

// const ALLOWED_PASSWORD_CHARS = /^[A-Za-z0-9!@#$%^&*()_+\-=[\]{}:;"',.?/~`]*$/;
// const PASSWORD_PATTERN =/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{}:;"',.?/~`])[A-Za-z0-9!@#$%^&*()_+\-=[\]{}:;"',.?/~`]{8,20}$/;


class InvitePage extends Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      first_name: "",
      last_name: "",
      email: "",
      code: "",
      password: "",
      confirmPassword: "",
      passwordsMatch: true,
      showTermsAndConditionsModal: false,
      attributeType: "password",
      attributeConfirmType: "password",
      isPasswordFieldsValid: false,
    };
  }

  componentDidMount() {
    try {
      const token: InviteToken = JSON.parse(atob(this.props.match.params.code));
      this.setState({ code: token.code, email: token.email });
      this.props.getInviteInfo(token);
    } catch (e) {
      console.error(e);
    }
  }

  componentDidUpdate(
    prevProps: Readonly<Props>,
    prevState: Readonly<State>
  ): void {
    if (
      prevProps.isLoading.getInviteInfo &&
      !this.props.isLoading.getInviteInfo &&
      this.props.inviteInfo
    ) {
      this.setState({
        first_name: this.props.inviteInfo.receiver.first_name,
        last_name: this.props.inviteInfo.receiver.last_name,
      });
    }
    if (
      prevProps.isLoading.acceptInvite &&
      !this.props.isLoading.acceptInvite
    ) {
      if (!this.props.errors.acceptInvite) {
        this.props.loginUser({
          username: this.state.email,
          password: this.state.password,
        });
      } else {
        toastr.error("Failed", this.props.errors.acceptInvite);
      }
    }
  }

  handleShowTACModal = () => {
    this.setState({ showTermsAndConditionsModal: true });
  };

  handleHideTACModal = () => {
    this.setState({ showTermsAndConditionsModal: false });
  };

 handleChange = (event: React.FormEvent<any>) => {
     const { name, value } = event.currentTarget;
 
     this.setState((prevState) => ({
         ...prevState,
         [name]: value,
       }), () => {
         const { password, confirmPassword } = this.state;
 
         const result = validatePasswordWithDOM(
           password,
           confirmPassword,
           "Password and Confirm Password fields do not match.",
           {
             newPasswordId: "new_password",
             newPasswordMsgId: "new_password_msg",
             confirmPasswordId: "confirm_new_password",
             confirmPasswordMsgId: "confirm_new_password_msg",
           }
         );
 
         this.setState({
           isPasswordFieldsValid: result.isPasswordFieldsValid,
           passwordsMatch: result.passwordsMatch,
         });
       }
     );
   };

  // handleChange = (event: React.FormEvent<any>) => {
  //   const { name, value } = event.target as HTMLInputElement;
  //   if (name === "password" || name === "confirmPassword") {
  //     if (!ALLOWED_PASSWORD_CHARS.test(value)) {
  //       return;
  //     }
  //   }
  //   let input, msg;
  //   if (name === "password") {
  //     input = document.getElementById("new_password");
  //     msg = document.getElementById("new_password_msg");
  //   }
  //   if (name === "confirmPassword") {
  //     input = document.getElementById("confirm_new_password");
  //     msg = document.getElementById("confirm_new_password_msg");
  //   }

  //   if (!PASSWORD_PATTERN.test(value) && value.length > 0 && (name === "password")) {
  //     if (input) input.style.border = "1px solid red";
  //     if (msg) msg.innerHTML = "Please match the format requested.";
  //   } else {
  //     if (input) input.style.border = "";
  //     if (msg) msg.innerHTML = "";
  //   }
  //   this.setState((prevState) => ({
  //     ...prevState,
  //     [name]: value,
  //     passwordsMatch: true,
  //   }));
  // };

  handleSubmit = (event: React.FormEvent<any>) => {
    event.preventDefault();
    // if (this.state.password !== this.state.confirmPassword) {
    //   this.setState({ passwordsMatch: false });
    //   const input = document.getElementById("confirm_new_password");
    //   const msg = document.getElementById("confirm_new_password_msg");
    //   if (input) input.style.border = "1px solid red";
    //   if (msg) msg.innerHTML = "Password and Confirm Password fields do not match.";
    //   return;
    // }
    // if (!PASSWORD_PATTERN.test(this.state.password)) {
    //       return;
    //     }
    this.handleShowTACModal();
  };

  acceptInvite = () => {
    const filledInvite: FilledInvite = {
      code: this.state.code,
      email: this.state.email,
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      password: this.state.password,
      password_confirmation: this.state.confirmPassword,
    };
    this.props.acceptInvite(filledInvite);
  };

  passwordShow = () => {
    this.setState({
      ...this.state,
      attributeType: this.state.attributeType === "password" ? "text": "password",
    })
  };

  confirmPasswordShow = () => {
    this.setState({
      ...this.state,
      attributeConfirmType: this.state.attributeConfirmType === "password" ? "text": "password",
    })
  };

  render() {
    const {
      email,
      password,
      confirmPassword,
      first_name,
      last_name,
      showTermsAndConditionsModal,
      attributeType,
      attributeConfirmType
    } = this.state;
    const { isLoading, inviteInfo } = this.props;
    if (isLoading.getInviteInfo) return <LoadingIndicator />;

    const appName = "ReadyCoach";
    return (
      <div>
        {inviteInfo ? (
          <>
            <Container className="loginContainer">
              <Row className="align-items-center">
                <Col sm>
                  <h1 className="hMax">
                    Sign up for <strong>{appName}</strong>
                  </h1>
                  <br />
                  <p className="text-white text-center mb-1">
                    You can sign up your district for <strong>{appName}</strong>
                  </p>
                  <p className="text-white text-center">
                    Once you have an account you'll be able to invite your staff
                    and begin coaching.
                  </p>
                  <hr />
                  <h2 className="text-white text-center">Have questions?</h2>

                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <button 
                      className="blueBtnMd m-2" 
                      onClick={() => window.open("https://readycoach.zendesk.com", "_blank", "noopener,noreferrer")}
                    >
                      Contact Us Today
                    </button>
                  </div>
                </Col>
                <Col sm>
                  <div className="welcomeInputContainer">
                    <div>
                      <h3 className="font-weight-bold">
                        Hi there, {inviteInfo.receiver.first_name}!
                      </h3>
                      <h3>
                        {`${inviteInfo.sent_by.first_name} ${inviteInfo.sent_by.last_name}`}{" "}
                        has invited you to create an account to manage your
                        classes. Choose a password and let's get you started!
                      </h3>
                      <br />
                    </div>
                    <Form onSubmit={this.handleSubmit}>
                      <FormGroup controlId="validation_email">
                        <FormLabel>
                          <h4 className="font-weight-bold mb-1">Email</h4>
                        </FormLabel>
                        <FormControl
                          required
                          autoFocus
                          name={"email"}
                          type="email"
                          value={email}
                          onChange={this.handleChange}
                          className="fullWidthInput"
                        />
                      </FormGroup>
                      <FormGroup controlId="validation_first_name">
                        <FormLabel>
                          <h4 className="font-weight-bold mb-1">First Name</h4>
                        </FormLabel>
                        <FormControl
                          required
                          name={"first_name"}
                          type="text"
                          value={first_name}
                          onChange={this.handleChange}
                          className="fullWidthInput"
                        />
                      </FormGroup>
                      <FormGroup controlId="validation_last_name">
                        <FormLabel>
                          <h4 className="font-weight-bold mb-1">Last Name</h4>
                        </FormLabel>
                        <FormControl
                          required
                          name={"last_name"}
                          type="text"
                          value={last_name}
                          onChange={this.handleChange}
                          className="fullWidthInput"
                        />
                      </FormGroup>
                      <FormGroup controlId="validation_password">
                        <FormLabel>
                          <h4 className="font-weight-bold mb-1">Password</h4>
                        </FormLabel>
                        <div className="input-container">
                          <FormControl
                            required
                            minLength={8}
                            maxLength={20}
                            name={"password"}
                            value={password}
                            onChange={this.handleChange}
                            type={attributeType}
                            id={`new_password`}
                          />
                          <FontAwesomeIcon  
                              onClick={this.passwordShow}  
                              icon={attributeType == 'password' ? faEye : faEyeSlash} 
                              className="icon-eye"
                            />
                        </div>
                        <div id={`new_password_msg`} style={{color:"red"}}></div>
                        <ul className="password-rules">
                          <li>At least 8 to at most 20 characters long</li>
                          <li>At least one uppercase letter (A-Z)</li>
                          <li>At least one lowercase letter (a-z)</li>
                          <li>At least one number (0-9)</li>
                          <li>At least one non-alphanumeric character (! @ # $ % ^ & * ( ) _ + - = [ ] { } : ; ' " , . ? / ~ `)</li>
                        </ul>
                      </FormGroup>
                      <FormGroup controlId="validation_confirmPassword">
                        <FormLabel>
                          <h4 className="font-weight-bold mb-1">
                            Confirm Password
                          </h4>
                        </FormLabel>
                        <div className="input-container">
                          <FormControl
                            required
                            minLength={8}
                            maxLength={20}
                            name={"confirmPassword"}
                            value={confirmPassword}
                            onChange={this.handleChange}
                            type={attributeConfirmType}
                            isInvalid={!this.state.passwordsMatch}
                            id={`confirm_new_password`}
                          />
                          <FontAwesomeIcon  
                              onClick={this.confirmPasswordShow}  
                              icon={attributeConfirmType == 'password' ? faEye : faEyeSlash} 
                              className="icon-eye"
                            />
                        </div>
                        <div id={`confirm_new_password_msg`} style={{color:"red"}}></div>
                        <Form.Control.Feedback type="invalid">
                          Passwords do not match.
                        </Form.Control.Feedback>
                      </FormGroup>
                      <div className="text-center">
                        <button type="submit" className="blueBtnMd" disabled={!this.state.isPasswordFieldsValid}>Sign Up</button>
                      </div>
                    </Form>
                  </div>
                </Col>
              </Row>
            </Container>
            <TermsAndConditionsModal
              showModal={showTermsAndConditionsModal}
              handleHideModal={this.handleHideTACModal}
              isLoading={isLoading.acceptInvite}
              onAccept={this.acceptInvite}
            />
          </>
        ) : (
          <Container>
            <Alert variant="danger">
              <Alert.Heading>
                Sorry, the invite you clicked has expired.
              </Alert.Heading>
            </Alert>
          </Container>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ auth }: ApplicationState): PropsFromState => {
  return {
    isLoading: {
      getInviteInfo: auth.isLoading.getInviteInfo,
      acceptInvite: auth.isLoading.acceptInvite,
    },
    errors: {
      getInviteInfo: auth.errors.getInviteInfo,
      acceptInvite: auth.errors.acceptInvite,
    },
    inviteInfo: auth.inviteInfo,
  };
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps =>
  bindActionCreators(
    {
      loginUser: loginUser,
      push: push,
      getInviteInfo: getInviteInfo,
      acceptInvite: acceptInvite,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(InvitePage);
